"use client";

import type { AthenaCoverageConfirmationMetadata } from "@/src/models/task-approval";

function expectedLabel(coverage: AthenaCoverageConfirmationMetadata["expectedCoverages"][number]): string {
  return coverage.casePolicy ? "Case policy" : coverage.order === 1 ? "Primary" : "Secondary";
}

function currentLabel(coverage: AthenaCoverageConfirmationMetadata["currentCoverages"][number]): string {
  return coverage.casePolicy
    ? "Case policy"
    : coverage.sequence === 1
      ? "Primary"
      : coverage.sequence === 2
        ? "Secondary"
        : "Unsequenced";
}

export function AthenaCoverageEvidence({ metadata }: { metadata: AthenaCoverageConfirmationMetadata }) {
  return (
    <>
      {metadata.reviewReasons.length ? (
        <div>
          <p className="font-medium">Issues</p>
          <ul className="list-disc space-y-1 pl-5 text-muted-foreground">
            {metadata.reviewReasons.map((reason) => (
              <li key={reason}>{reason}</li>
            ))}
          </ul>
        </div>
      ) : null}
      <div>
        <p className="font-medium">Expected</p>
        <ul className="list-disc pl-5">
          {metadata.expectedCoverages.map((coverage) => (
            <li key={coverage.order}>
              {expectedLabel(coverage)}: {coverage.label}
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-medium">Currently in Athena</p>
        <ul className="list-disc pl-5">
          {metadata.currentCoverages.length === 0 ? (
            <li>No coverage found</li>
          ) : (
            metadata.currentCoverages.map((coverage) => (
              <li key={coverage.insuranceId}>
                {currentLabel(coverage)}: {coverage.planName ?? "Unknown plan"} (package{" "}
                {coverage.insurancePackageId ?? "missing"})
                {coverage.subscriberId ? ` · Subscriber ${coverage.subscriberId}` : ""}
              </li>
            ))
          )}
        </ul>
      </div>
    </>
  );
}
